import * as React from 'react';

import { Alert } from '@lightspeed/flame/Alert';
import { Button } from '@lightspeed/flame/Button';
import { Card, CardHeader, CardSection } from '@lightspeed/flame/Card';
import { Box, Flex } from '@lightspeed/flame/Core';
import { theme } from '@lightspeed/flame/Core/themes/flame';
import { Spinner } from '@lightspeed/flame/Spinner';
import { Text } from '@lightspeed/flame/Text';

import { ErrorMessageContext } from 'root/apps/InventoryCount/contexts/ErrorMessage';
import { StatusDataContext } from 'root/apps/InventoryCount/contexts/StatusData';

import ResetImportModal from './ResetImportModal';

const ImportOverview: React.FC = () => {
  const { error } = React.useContext(ErrorMessageContext);
  const { data, isLoading, ImportProcess } = React.useContext(StatusDataContext);
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const resetState = (state: boolean) => {
    setIsModalOpen(state);
  };

  const handleClick = () => {
    ImportProcess();
  };

  return (
    <Box data-test="import-overview-view" px={2} pt={20} height={350}>
      {error ? (
        <Alert type="danger" noCloseBtn mb={2}>
          {error.message}
        </Alert>
      ) : null}
      <Flex flexDirection="column" justifyContent="space-between" height={error ? '85%' : '100%'}>
        <Box>
          <Flex flexDirection="column" paddingBottom={2}>
            <Text
              fontWeight={600}
              style={{ textTransform: 'uppercase' }}
              pb={1}
              color={theme.colors.black}
              letterSpacing={2}
            >
              Import Overview
            </Text>
            <Text pb={2}>
              Review your import and make sure the items and count are correct before importing.
            </Text>
          </Flex>
          <Box>
            <Flex>
              <Card
                style={{ width: '50%', borderRadius: '0.375rem 0 0 0.375rem', padding: '0 30px' }}
              >
                <CardHeader style={{ border: 'none', padding: '0' }}>
                  <Text fontSize="1rem" p={0} color={theme.colors.textDimmed}>
                    Items
                  </Text>
                </CardHeader>
                <CardSection data-test="overview-total-items" style={{ padding: '0 0 15px 0' }}>
                  <Text fontSize="2rem" fontWeight={600} color={theme.colors.black}>
                    {data?.totalItems ? data.totalItems : <span className="notranslate">-</span>}
                  </Text>
                </CardSection>
              </Card>
              <Card
                style={{ width: '50%', borderRadius: '0 0.375rem 0.375rem 0', padding: '0 30px' }}
              >
                <CardHeader style={{ border: 'none', padding: '0' }}>
                  <Text fontSize="1rem" p={0} color={theme.colors.textDimmed}>
                    Count
                  </Text>
                </CardHeader>
                <CardSection data-test="overview-total-qty" style={{ padding: '0 0 15px 0' }}>
                  <Text fontSize="2rem" fontWeight={600} color={theme.colors.black}>
                    {data?.totalQty ? data.totalQty : <span className="notranslate">-</span>}
                  </Text>
                </CardSection>
              </Card>
            </Flex>
          </Box>
        </Box>
        <Box>
          <Flex justifyContent="right" pb={3}>
            <Button
              data-test="map-column-restart-import-btn"
              height={30}
              p={0}
              size="small"
              variant="default"
              fill
              onClick={() => setIsModalOpen(true)}
            >
              Restart import
            </Button>
            <Button
              variant="secondary"
              fill
              width={90}
              height={30}
              p={0}
              ml={1}
              size="small"
              className="track-inventory-count-import-import-btn"
              onClick={() => handleClick()}
            >
              {isLoading ? <Spinner /> : 'Import'}
            </Button>
          </Flex>
        </Box>
      </Flex>
      <ResetImportModal isModalOpen={isModalOpen} resetState={resetState} />
    </Box>
  );
};

export default ImportOverview;
